import Checkbox, { CustomCheckboxProps } from './Checkbox.component';

export type CheckboxProps = CustomCheckboxProps;

export default Checkbox;
